import { bigIntToLong } from '#common/util';
import { ServiceBaseProto, SnapshotMsg, SnapshotRequestMsg } from '#websocket/client/proto';
export const SNAPSHOT_REQUEST = '.SnapshotRequestMsg.snapshotRequest';
export const SNAPSHOT_RESPONSE = '.SnapshotResponseMsg.snapshotResponse';
export class SnapshotRequest {
    properties;
    destination;
    constructor(properties, destination) {
        this.properties = properties;
        this.destination = destination;
    }
    createMessage(requestId, version) {
        return ServiceBaseProto.RequestMsg.create({
            id: bigIntToLong(requestId),
            versionMajor: version.major,
            versionMinor: version.minor,
            versionBuild: version.build,
            [SNAPSHOT_REQUEST]: SnapshotRequestMsg.create(this.properties),
        });
    }
    getDestination() {
        return this.destination;
    }
    createResponse(responseMessage) {
        return new SnapshotResponse(responseMessage);
    }
}
export class SnapshotResponse {
    snapshots = new Array();
    constructor(response) {
        const responseMsgObject = ServiceBaseProto.ResponseMsg.toObject(response);
        const snapshotResponseMsg = responseMsgObject[SNAPSHOT_RESPONSE];
        if (snapshotResponseMsg.snapshots) {
            this.snapshots = snapshotResponseMsg.snapshots.map((snapshotMsg) => new SnapshotMsg(snapshotMsg));
        }
    }
}
